// The three identifiers that say "this JSON is a deck this app can open".
//
// They live in their own module because both halves of the contract need them:
// deckContract.js, which writes the schema an assistant is given, and
// deckStyles.js, which builds the example deck that goes with it — and
// deckContract imports deckStyles, so the constants cannot live in either.
export const DECK_FORMAT = 'boppps_lesson';
export const DECK_VERSION = '4.0.0';
export const DECK_SCHEMA_TYPE = 'full_deck';
